/**
 * The model indicating options for sending correspondence
 */
export class CorrespondenceSendOptionsModel {
    /**
     * Indicates whether correspondence can be sent via email
    */
    public allowEmail = true;
    /**
     * Indicates whether correspondence can be sent via USPS
    */
    public allowUsps = true;
    /**
     * Indicates whether correspondence should be sent via email
    */
    public preferredEmail = false;
    /**
     * Indicates whether correspondence should be sent via USPS
    */
    public preferredUsps = false;
}
